import React, { useEffect, useState } from "react";
import Modal from "@/components/chat/Modal";
import { Check } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { toast } from "sonner";

export default function SocialSettings({ onClose }) {
  const { t } = useI18n();
  const [months, setMonths] = useState(0);
  const OPTIONS = [[0, t("ss_never")], [1, t("ss_1m")], [3, t("ss_3m")], [6, t("ss_6m")], [12, t("ss_12m")]];
  useEffect(() => { api.get("/social/settings").then(({ data }) => setMonths(data.autodelete_months)).catch(() => {}); }, []);
  const pick = async (m) => {
    setMonths(m);
    try { await api.put("/social/settings", { autodelete_months: m }); toast.success(t("ss_saved")); } catch { toast.error(t("s_failed")); }
  };
  return (
    <Modal title={t("ss_title")} onClose={onClose}>
      <div data-testid="social-settings">
        <p className="text-sm text-[var(--rc-muted)] mb-3">{t("ss_desc")}</p>
        <div className="space-y-2">
          {OPTIONS.map(([m, label]) => (
            <button key={m} onClick={() => pick(m)} data-testid={`autodelete-${m}`}
              className={`w-full flex items-center justify-between rounded-xl border px-4 py-3 text-sm ${months === m ? "border-[var(--rc-gold)] bg-[var(--rc-gold)]/10 text-[var(--rc-gold)]" : "border-[var(--rc-border)] text-[var(--rc-text)]"}`}>
              {label} {months === m && <Check size={16} />}
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
}
